import { perror } from '../../../utils/plog';

/* eslint-disable no-shadow, no-unused-vars */
enum SpecialtyName {
  ANESTHESIOLOGIST = 'anesthesiologist',
  ANESTHESIOLOGIST_INTENSIVIST = 'anesthesiologistIntensivist',
  CARDIOLOGIST = 'cardiologist',
  ENDOCRINOLOGIST = 'endocrinologist',
  GENERAL_SURGEON = 'generalSurgeon',
  INTERNIST = 'internist',
  ORTHOPEDIC_SURGEON = 'orthopedicSurgeon',
  OTOLARYNGOLOGIST = 'otolaryngologist',
  PNEUMOLOGIST = 'pneumologist'
}

export enum FamilyName {
  ANESTHESIOLOGY,
  INTERNIST,
  SURGERY
}

export default SpecialtyName;

export const SPECIALTY_TO_FAMILY = {
  [SpecialtyName.ANESTHESIOLOGIST]: FamilyName.ANESTHESIOLOGY,
  [SpecialtyName.ANESTHESIOLOGIST_INTENSIVIST]: FamilyName.ANESTHESIOLOGY,
  [SpecialtyName.CARDIOLOGIST]: FamilyName.INTERNIST,
  [SpecialtyName.ENDOCRINOLOGIST]: FamilyName.INTERNIST,
  [SpecialtyName.GENERAL_SURGEON]: FamilyName.SURGERY,
  [SpecialtyName.INTERNIST]: FamilyName.INTERNIST,
  [SpecialtyName.ORTHOPEDIC_SURGEON]: FamilyName.SURGERY,
  [SpecialtyName.OTOLARYNGOLOGIST]: FamilyName.SURGERY,
  [SpecialtyName.PNEUMOLOGIST]: FamilyName.INTERNIST
};

export const SPECIALTY_NAME_TO_ID = {
  [SpecialtyName.ANESTHESIOLOGIST]: '03',
  [SpecialtyName.ANESTHESIOLOGIST_INTENSIVIST]: '03',
  [SpecialtyName.CARDIOLOGIST]: '06',
  [SpecialtyName.ENDOCRINOLOGIST]: '35',
  [SpecialtyName.GENERAL_SURGEON]: '07',
  [SpecialtyName.INTERNIST]: '18',
  [SpecialtyName.ORTHOPEDIC_SURGEON]: '07',
  [SpecialtyName.OTOLARYNGOLOGIST]: '25',
  [SpecialtyName.PNEUMOLOGIST]: '17'
};

export const getUserSpecialtyId = (specialtyName: SpecialtyName) => {
  const specialtyId = SPECIALTY_NAME_TO_ID[specialtyName];

  if (specialtyId === undefined) {
    perror(`unable to find id for specialty ${specialtyName}`);
  }

  return specialtyId;
};
